/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  DatePicker,
} from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';
/*
import {
  getDiasFestivosDelAñoPag,
  getDiasFestivosDelAño,
  postDiaFestivoDelAño,
  deleteDiaFestivoDelAño,
  patchDiaFestivoDelAño,
  getDiaFestivoDelAño,
  autorizarDiaFestivoDelAño,
} from 'api/configuraciones/clock/DiasFestivos/FestivosDelAño'; */
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
} from 'utils/constants';
import moment from 'moment';

const IncidenciaResumenReloj = ({ permission, parent_data }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [disableFields, setDisableFields] = useState(false);

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      fecha: record.fecha
        ? moment(record.fecha)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado_id',
      key: 'empleado_id',
      width: 150,
    },
    {
      titleText: 'Nombre del Empleado',
      dataIndex: 'numero_y_nombre_completo_empelado',
      key: 'numero_y_nombre_completo_empelado',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 120,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 190,
    },
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Incidencia de Reloj Checador',
      dataIndex: 'tipo_de_evaluacion_de_asistencia_nombre',
      key: 'tipo_de_evaluacion_de_asistencia_nombre',
      width: 230,
    },
    {
      titleText: 'No. de Incidencias',
      dataIndex: 'numero_incidencias',
      key: 'numero_incidencias',
      width: 180,
    },
    {
      titleText: 'Minutos de Incidencia',
      dataIndex: 'minutos_incidencia',
      key: 'minutos_incidencia',
      width: 180,
    },
    {
      titleText: 'Cantidad de Descuento',
      dataIndex: 'cantidad_descuento',
      key: 'cantidad_descuento',
      width: 200,
    },
    // {
    //   titleText: 'Unidad de Descuento',
    //   dataIndex: 'unidad_descuento_descripcion',
    //   key: 'unidad_descuento_descripcion',
    //   width: 200,
    // },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={parent_data}
          allowExportPDF={false}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          permission={permission}
        />
      </Spin>
    </Row>
  );
};

export default IncidenciaResumenReloj;
